<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                封鎖騎士
            </div>
            <div class="subtitle">
                <span class="red">* 封鎖後該騎士將無法再服務您的訂單 *</span>
            </div>
            <div class="content">
                <input type="text" placeholder="理由 (選填)" v-model="note">
            </div>
            <loading loader="spinner"
                     :height="30"
                     :opacity="0.8"
                     :active="isLoading">
                <template slot="before">
                    <div>封鎖中</div>
                </template>
            </loading>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onCancel">
                返回
            </div>
            <div class="confirm button" @click="onConfirm">
                我要封鎖
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import { mapActions } from 'vuex';
    import Loading from 'vue-loading-overlay';
    import Swal from 'sweetalert2'
    import { blockDriver} from "../../../apis";

    export default {
        name: 'BlockKnightModal',
        components: {
            'p-modal': Modal,
            'loading': Loading,
        },
        data() {
            return {
                isLoading: false,
                display: false,
                knightId: 0,
                note: '',
            };
        },
        methods: {
            onConfirm() {
                this.isLoading = true;
                blockDriver({
                    id: this.knightId,
                    data: {
                        'note': this.note,
                    }
                }).then(() => {
                    this.isLoading = false;
                    this.display = false;
                    this.getBlockIds();
                    this.$emit('onConfirm');
                }).catch(err => {
                    this.isLoading = false;
                    this.display = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                }).finally(() => {
                    this.note = '';
                });
            },
            onCancel() {
                this.display = false;
                this.$emit('onCancel');
            },
            show(knightId) {
                this.display = true;
                this.knightId = knightId;
            },
            ...mapActions(['getBlockIds'])
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;

        span {
            &.red {
                color: #F44336;
                font-weight: 500;
            }
        }
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-family: "PingFang TC";
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: rgba(244,67,54,1);
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
